var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b", [_vm._v("Locations")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: {
                    type: "button",
                    variant: "outline-primary",
                    size: "sm"
                  },
                  on: {
                    click: function($event) {
                      _vm.showCreateLocationModal = true
                    }
                  }
                },
                [
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v("Add Location")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.formatLocations && _vm.formatLocations.length > 0
            ? _c(
                "div",
                _vm._l(_vm.formatLocations, function(location) {
                  return _c(
                    "b-list-group",
                    { key: location.id, attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showUpdateLocationMod(location)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(location.title) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.defaultLocationId == location.id
                          ? _c("img", {
                              attrs: {
                                src: "static/img/Primary.png",
                                height: "21",
                                width: "21"
                              }
                            })
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatLocations.length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                !_vm.hasLocations
                                  ? "This Organization does not have any Locations."
                                  : "Howdy!"
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("CreateLocationModal", {
        attrs: {
          showModal: _vm.showCreateLocationModal,
          organizationId: _vm.organizationId,
          orgLocations: _vm.orgLocations
        },
        on: {
          "update:showModal": function($event) {
            _vm.showCreateLocationModal = $event
          },
          "update:show-modal": function($event) {
            _vm.showCreateLocationModal = $event
          }
        }
      }),
      _vm._v(" "),
      _c("UpdateLocationModal", {
        attrs: {
          showModal: _vm.showUpdateLocationModal,
          organizationId: _vm.organizationId,
          selectedLocationRec: _vm.selectedLocationRec,
          orgLocations: _vm.orgLocations,
          disableDelete: _vm.disableDeleteVar
        },
        on: {
          "update:showModal": function($event) {
            _vm.showUpdateLocationModal = $event
          },
          "update:show-modal": function($event) {
            _vm.showUpdateLocationModal = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cdfc44fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdfc44fa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/LocationList.vue
// module id = 1891
// module chunks = 0